export const turmas = [
  { id: '1', nome: '1º Ano A' },
  { id: '2', nome: '1º Ano B' },
  { id: '3', nome: '2º Ano A' },
  { id: '4', nome: '2º Ano B' },
  { id: '5', nome: '3º Ano A' },
  { id: '6', nome: '3º Ano B' }
];

export const alunos = [
  {
    id: '1',
    nome: 'Ana Beatriz',
    turmaId: '1',
    dataEntrada: '2024-02-05',
    dataNascimento: '2012-08-14'
  },
  {
    id: '2',
    nome: 'Bruno Henrique',
    turmaId: '1',
    dataEntrada: '2024-02-05',
    dataNascimento: '2012-11-02'
  },
  {
    id: '3',
    nome: 'Camila Souza',
    turmaId: '2',
    dataEntrada: '2024-02-06',
    dataNascimento: '2012-03-19'
  },
  {
    id: '4',
    nome: 'Diego Martins',
    turmaId: '2',
    dataEntrada: '2024-02-06',
    dataNascimento: '2012-07-22'
  },
  {
    id: '5',
    nome: 'Eduarda Lima',
    turmaId: '3',
    dataEntrada: '2023-02-08',
    dataNascimento: '2011-01-10'
  },
  {
    id: '6',
    nome: 'Felipe Rocha',
    turmaId: '3',
    dataEntrada: '2023-02-08',
    dataNascimento: '2011-05-27'
  },
  {
    id: '7',
    nome: 'Gabriela Silva',
    turmaId: '4',
    dataEntrada: '2023-02-09',
    dataNascimento: '2011-09-03'
  },
  {
    id: '8',
    nome: 'Henrique Alves',
    turmaId: '4',
    dataEntrada: '2023-02-09',
    dataNascimento: '2011-12-15'
  },
  {
    id: '9',
    nome: 'Isabela Costa',
    turmaId: '5',
    dataEntrada: '2022-02-10',
    dataNascimento: '2010-04-21'
  },
  {
    id: '10',
    nome: 'João Pedro',
    turmaId: '6',
    dataEntrada: '2022-02-10',
    dataNascimento: '2010-10-30'
  }
];
